import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

// Import jQuery et Select2 globalement
import $ from 'jquery'
window.$ = window.jQuery = $
import 'select2'
import 'select2/dist/css/select2.min.css'

// Import Chart.js globally
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

// Material Icons - Pour garder la même apparence que l'application d'origine
import './assets/main.css'
import './assets/cropper.css'
import './assets/css/variables.css' // Palette de couleurs turquoise OpSolver
import 'material-icons/iconfont/material-icons.css'

// Import Material Design Lite CSS pour compatibilité avec l'ancien design
import 'material-design-lite/material.min.css'

// Créer l'application
const app = createApp(App)

// Configurer Pinia
const pinia = createPinia()

// Enregistrer les plugins
app.use(router)
app.use(pinia)

// Monter l'application
app.mount('#app')
